import React from 'react';

import './door_designer.css';

export default function DoorDesigner() {
    return (
        <main className="door-designer">
            <iframe
                className="door-designer__frame"
                src="https://app.glazingvault.com/system/168"
                title="Design your door"
                allowFullScreen
            />
        </main>
    );
}
